module.exports = __webpack_public_path__ + "img/1.69437963.png";